export default __webpack_public_path__ + "static/media/magpul-pdr.ad9eefa9.svg";